<template>
    <ac-modal :title="'Remove Debt'" ref="modal">
        <template>
            <div>
                <div class="alert alert-info">
                    You are about to cancel the member debt, 
                    doing so will remove this debt completely for the member. 
                    This cannot be undone once it is processed.
                </div>
                Debt summary for {{ member }}<br/>
                <span style="font-weight: bold !important;">Total debt: {{ netDebt | currency }}</span>
                <hr/>
                <div class="row">
                    <div class="col-md-6 form-group" v-for="dr in debtRecords" :key="dr.consumerDebtId">
                        <ul style="padding: 5px">
                            <li>
                                <input type="checkbox" class="filled-in" :id="'remove-'+dr.consumerDebtId" v-model="dr.isChecked">
                                <label :for="'remove-'+dr.consumerDebtId">
                                    Remove debt for {{ monthName(dr.month) }} <span v-if="dr.year">{{ dr.year }}</span>
                                </label><br>
                                <span>Amount due to provider: </span>{{ dr.debt | currency }}<br>
                                <span>Other dues : </span>{{ dr.feesDebt | currency }}<br>
                                <span>Reason: </span>{{ dr.reason }}<br>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="button-box">
                    <ac-button class="btn btn-red btn-sm" :action="cancelRemoveDebt">CANCEL
                    </ac-button>
                    <ac-button class="btn btn-green btn-sm" :action="removeDebt">REMOVE DEBT
                    </ac-button>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../global/framework/api.js";
    import AcButton from "../../../global/customHtmlElements/AcButton.vue";
    import {formatter} from "../../../global/formatter.js";
    import {common} from "../../../global/common.js";

    export default {
        name: "DebtRemovalModal",
        components: {AcButton},
        data() {
            return {
                netDebt: 0,
                debtRecords: [],
                member: '',
                consumerId: 0,
                providerEntityId: 0
            };
        },
        methods: {
            monthName(monthNum) {
                return common.getMonthName(monthNum);
            },
            async showModal({consumerId, providerEntityId}) {
                this.consumerId = consumerId;
                this.providerEntityId = providerEntityId;
                let [debtInfo] = await Promise.all([
                    api.getDataWithTwoIds('ProviderPayments', providerEntityId, 'GetDebtInfo', consumerId),
                ]);

                this.debtRecords = debtInfo.debtRecords.map(x => { x.isChecked = true; return x; });
                this.netDebt = debtInfo.netDebt;
                this.member = `${this.debtRecords[0].firstName} ${this.debtRecords[0].lastName}`;
                this.widgetReady = true;
                this.$refs.modal.open();
            },
            cancelRemoveDebt() {
                this.$refs.modal.close();
            },
            async removeDebt() {
                let records = this.debtRecords.filter(x => x.isChecked).map(y => y.consumerDebtId);
                let data = {
                    consumerId: this.consumerId, 
                    providerResolvingPayment: this.providerEntityId,
                    consumerDebtIds: records,
                }
                let result = await api.post('ProviderPayments', 'RemoveDebt', data);

                if (result) {
                    this.$refs.modal.close();
                    this.$bus.$emit(this.$AcEvents.DEBT_HAS_BEEN_RESOLVED, result);
                }
            }
        }
    }
</script>

<style scoped>

</style>